/**
 * Service Feedback & suggestions — aucun logique métier, uniquement des appels API.
 * Le client `api` inclut les cookies, parse le JSON et lève une Error sur réponse !ok.
 */

import { api, endpoints } from './api.js'

const e = endpoints.feedback

export const feedbackService = {
  /** params: { status?, search?, sort, page, perPage } — les vides sont ignorés. */
  list: (params) => api.get(e.list(params)),
  summary: () => api.get(e.summary()),
  get: (id) => api.get(e.detail(id)),
  create: (payload) => api.post(e.create(), payload),
  update: (id, payload) => api.patch(e.detail(id), payload),
  remove: (id) => api.delete(e.detail(id)),
  vote: (id, value) => api.post(e.vote(id), { value }),
  createComment: (id, payload) => api.post(e.comments(id), payload),
  deleteComment: (id, commentId) => api.delete(e.comment(id, commentId)),
  uploadImage: (formData) => api.post(e.uploadImage(), formData),
}
